import {atom} from "recoil";
export const matriculasByResponsavelResponseState = atom({
  key: 'matriculasByResponsavelState',
  default: null,
  effects: [
    // Nunca em hipótese alguma adicione o efeito de persistir isso no storage, afeta a contratação
  ]
});